import React from "react";
import { render } from "react-dom";
import { Router, Redirect, Route } from "react-router-dom";
// componets for the application
import App from "./App";
import Login from "./components/Pages/Login";
import QueryComponent from "./QueryComponent";
import auth from "./helpers/auth";
import { createBrowserHistory } from "history";
import * as serviceWorker from "./registerServiceWorker";
import Firebase, { FirebaseContext } from "./Firebase";

const history = createBrowserHistory();

render(
  <FirebaseContext.Provider value={new Firebase()}>
    <Router history={history}>
      <App>
        <Route
          path="/"
          render={() =>
            auth.loggedIn() ? <QueryComponent /> : <Redirect to={"/login"} />
          }
        />
        <Route path="/login" component={Login} />
      </App>
    </Router>
  </FirebaseContext.Provider>,
  document.getElementById("app")
);

serviceWorker.register();



// WEBPACK FOOTER //
// ./src/index.js